import { render, staticRenderFns } from "./NomePassagem.vue?vue&type=template&id=518972df&scoped=true"
import script from "./NomePassagem.vue?vue&type=script&lang=js"
export * from "./NomePassagem.vue?vue&type=script&lang=js"
import style0 from "./NomePassagem.vue?vue&type=style&index=0&id=518972df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518972df",
  null
  
)

export default component.exports